export const HANDLING_UNIT_COLUMN_WIDTHS = {
  handlingUnit: 200,
  dimension: 76,
  dimensionUnit: 90,
  weight: 96,
  weightUnit: 100,
  qty: 76,
  nmfc: 156,
  stop: 240,
  toggle: 96,
  crating: 150,
  temperature: 216,
  dangerous: 216,
  unNumber: 101,
  additional: 346,
} as const;

export const CONTAINER_COLUMN_WIDTHS = {
  containerType: 299,
  weight: 190,
  weightUnit: 100,
  qty: 76,
  stop: 240,
  toggle: 90,
  temperature: 218,
  dangerous: 220,
  additional: 370,
} as const;

export const COMMODITY_COLUMN_WIDTHS = {
  parentPicker: 190,
  description: "minmax(400px, 1fr)",
  hsCode: 180,
  valueInput: 110,
  currency: 100,
  valueColumn: 210,
} as const;
